export interface IHolidayCalendarStoreData {
  data: {calendar_json: IHolidayCalendarData};
  t: number;
  success: boolean;
}

export interface IHolidayCalendarData {
  template: {(key: string): Array<IYearHolidayCalendarData>};
  success: boolean;
}

export interface IYearHolidayCalendarData {
  (key: string): Array<IMonthHolidayCalendarData>;
}

export interface IMonthHolidayCalendarData {
  (key: string): IHolidayDetail;
}

export interface IHolidayDetail {
  name: string;
}

export const UPDATE_HOLIDAY_CALENDAR = 'UPDATE_HOLIDAY_CALENDAR';

export interface IUpdateholidayCalendarData {
  type: typeof UPDATE_HOLIDAY_CALENDAR;
  actionData: IHolidayCalendarData;
}

export type holidayCalendarActionTypes = IUpdateholidayCalendarData;
